// Shared control language for page-header toolbars (the Projects toolbar in
// `routes/ask-puntt/campaigns.tsx` and the Documents header in
// `routes/tickets/components/TicketsHeader.tsx`). Both headers import these
// tokens so their search field, participants control, view toggle, and primary
// button share one height, border, radius, and icon scale.

/** Radix Themes control size used by every native toolbar control (Button, TextField, SegmentedControl). */
export const TOOLBAR_CONTROL_SIZE = "2" as const;

/** Fixed height that matches a Radix size-2 control (32px). Applied to hand-rolled controls. */
export const TOOLBAR_CONTROL_HEIGHT = "h-8";

/** The single border token shared by every bordered toolbar control. */
export const TOOLBAR_BORDER = "border border-puntt-neutral-gray-6";

/** The single corner radius shared by every toolbar control. */
export const TOOLBAR_RADIUS = "rounded-md";

/** Icon size (px) for icons rendered inside toolbar controls. */
export const TOOLBAR_ICON_SIZE = 16;

/** Container class for a hand-rolled, segmented view toggle. */
export const TOOLBAR_TOGGLE_CONTAINER = `flex ${TOOLBAR_CONTROL_HEIGHT} items-stretch overflow-hidden ${TOOLBAR_RADIUS} ${TOOLBAR_BORDER}`;

/**
 * Class for a single hand-rolled view-toggle button. Buttons stretch to the
 * shared control height and only differ by their active/inactive colors, so the
 * toggle never renders taller than the sibling Button/TextField controls.
 */
export function toolbarToggleButtonClass(isActive: boolean): string {
  const base =
    "flex cursor-pointer items-center justify-center px-2.5 transition-colors";
  const colors = isActive
    ? "bg-puntt-accent-3 text-puntt-accent-11"
    : "bg-base-white text-puntt-neutral-gray-9 hover:bg-puntt-neutral-gray-2";
  return `${base} ${colors}`;
}
